export default {
    path: 'settingWhiteList',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/settingWhiteList/index'),
    meta: {title:'下发白名单'}
}